import { render, staticRenderFns } from "./EditElementQuestion.vue?vue&type=template&id=ddfe42d2"
import script from "./EditElementQuestion.vue?vue&type=script&lang=js"
export * from "./EditElementQuestion.vue?vue&type=script&lang=js"
import style0 from "./EditElementQuestion.vue?vue&type=style&index=0&id=ddfe42d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports